/**
 * @class InspectionCardElement
 */
export class InspectionCardElement {
  /**
   * @typedef {object} InspectionCardElementConstructorPayload
   * @property {string} [id] hash
   * @property {string} [label]
   * @property {string} type
   * @property {number|string} [order = 1]
   * @property {number|string} template_id
   */
  /** @param {InspectionCardElementConstructorPayload|object} payload */
  constructor(payload) {
    this.id = payload?.id ?? null;
    this.label = payload?.label ?? null;
    this.type = payload?.type ?? null;
    this.order = payload?.order ?? 1;
    this.template_id = payload?.template_id ?? null;
  }

  static enum = {
    types: {
      Block: 'block',
      Category: 'category',
    },
  };
}
